type AuthTypeProps = {
  id: string
  name: string
}

export const AuthTypes = [
  {
    "id": "1",
    "name": "Nenhuma"
  },
  {
    "id": "2",
    "name": "Certificado digital (mTLS)"
  },
] as AuthTypeProps[]
